export class AsyncEventEmitterSubscriber<T> {
  private callback: (func: T) => Promise<void>;

  constructor(callback: (func: T) => Promise<void>)
  {
    this.callback = callback;
  }

  public async call(value?: T): Promise<void>
  {
    await this.callback(value);
  }
}

export class AsyncEventEmitter<T>
{
  private subscriptions: Array<AsyncEventEmitterSubscriber<T>> = [];

  public subscribe(callback: any): AsyncEventEmitterSubscriber<T>
  {
    const subscriber = new AsyncEventEmitterSubscriber<T>(callback);
    this.subscriptions.push(subscriber);
    return subscriber;
  }

  public unsubscribe(subscriber: AsyncEventEmitterSubscriber<T>): void
  {
    this.subscriptions.splice(this.subscriptions.indexOf(subscriber), 1);
  }

  public async emit(value?: T): Promise<void>
  {
    await Promise.all(this.subscriptions.map(s => s.call(value)));
  }
}
